import { createFileRoute } from "@tanstack/react-router";
import Inicio from "@/pages/admin/Inicio";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/")({
  head: () => pageHead({ title: "Início | Painel", path: "/admin", noindex: true }),
  component: Inicio,
});
